<div *ngIf="ResetPassword" class="text-center" style="padding: 15px;">
  <div class="row" style="margin: 30px 0px 70px 0px;">
    <div class="col-lg-12">
      <h3>{{'AUTH.GENERAL.FORGOTPASSWORD' | translate}}</h3>
    </div>
  </div>
  <div mat-dialog-content style="margin-top: 15px">
    <div class="signup-item">
      <div class="signup-form">
        <form class="login-form" [formGroup]="forgetPasswordForm">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <input type="password" class="form-control" placeholder="{{'AUTH.INPUT.NEWPASSWORD' | translate}}"
                  formControlName="NewPassword" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
                <div class="text-danger"
                  *ngIf="controlHasError('required', 'NewPassword') && isControlTouched('ConfirmPassword')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                </div>
                <div class="text-danger"
                  *ngIf="!forgetPasswordForm.get('NewPassword').valid && forgetPasswordForm.get('NewPassword').touched">
                  {{ 'AUTH.VALIDATION.PASSWORDCONS'| translate }}
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <input type="password" class="form-control" placeholder="{{'AUTH.INPUT.CONFIRM_PASSWORD' | translate}}"
                  formControlName="ConfirmPassword" autocomplete="off" readonly
                  onfocus="this.removeAttribute('readonly');">
                <div class="text-danger"
                  *ngIf="controlHasError('required', 'ConfirmPassword')  && isControlTouched('ConfirmPassword')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                </div>
                <ng-container
                  *ngIf="forgetPasswordForm.controls['ConfirmPassword'].errors &&
                    forgetPasswordForm.controls['ConfirmPassword'].errors.ConfirmPassword && isControlTouched('ConfirmPassword')">
                  <div class="text-danger">
                    {{ 'AUTH.VALIDATION.DIDNOTMATCH_FIELD'| translate }}
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-lg-12" style="font-size: 15px;">
              <p>{{ language == 'en'? 'Please create a new password that meets the following criteria:':'الرجاء إنشاء كلمة مرور جديدة تستوفي المعايير التالية:' }} </p>
              <p>{{ language == 'en'? 'Must be at least 6 characters, Include numbers.':'يجب أن لا يقل عن 6 أحرف، بما في ذلك الأرقام.' }} </p>
              <p>{{ language == 'en'? 'Include at least one uppercase letter.':'قم بتضمين حرف كبير واحد على الأقل.' }}</p>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
  <div class="text-center" style="margin-top: 30px;">
    <div class="col-lg-12">
      <div class="text-center">
        <button style="font-weight: bold;" type="button" class="btn btn-success" (click)="submit()">{{ 'COMMON.SAVE' |
          translate }}</button>
        <button type="button" style="margin: 10px;font-weight: bold;" class="btn btn-danger" (click)="onNoClick()">{{
          'COMMON.BACK' |
          translate }}</button><br>
        <ng-container *ngIf="isLoading$ | async">
          <div class="spinner-border" role="status" style="margin-top: 30px;">
            <span class="visually-hidden"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div *ngIf="ValidateOtp" class="text-center" style="padding: 15px;">
  <div class="row" style="margin: 30px 0px 20px 0px;">
    <div class="col-lg-12">
      <h3>{{'AUTH.INPUT.ENTERCODE' | translate}}</h3>
      <p>{{'AUTH.INPUT.ENTERCODEPARA' | translate}}</p>
    </div>
  </div>
  <div mat-dialog-content>
    <div class="signup-item">
      <div class="signup-form">
        <div class="row">
          <div class="col-lg-4"></div>
          <div class="col-lg-4">
            <div class="form-group">
              <input type="text" class="form-control" [(ngModel)]="OtpCode" autocomplete="off">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center" style="margin-top: 30px;">
    <div class="col-lg-12">
      <div class="text-center">
        <button style="font-weight: bold;" type="button" class="btn btn-success" (click)="ValidateOtpCode()">{{
          'CONTACTUS.SEND' |
          translate }}</button>

        <button type="button" style="margin: 10px;font-weight: bold;" class="btn btn-danger" (click)="onNoClick()">{{
          'COMMON.BACK' |
          translate }}</button><br>
        <ng-container *ngIf="isLoading$ | async">
          <div class="spinner-border" role="status" style="margin-top: 30px;">
            <span class="visually-hidden"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>